class ProductGallery {
	constructor() {
		if (!document.body.classList.contains("single-product")) {
			return;
		}

		if (document.querySelectorAll(".gallery-horizontal-slide .shadow-container").length === 0){
			return;
		}

		const scroller = document.querySelector(".gallery-horizontal-slide");

		gsap.to(scroller, {
			x: -this.getDuration(scroller),
			scrollTrigger: {
				trigger: scroller,
				start: "top 10%",
				end: () => `+=${this.getDuration(scroller) * 1.5}`,
				scrub: true,
				anticipatePin: 1,
				pin: scroller,
			}
		});

		setTimeout(() => {
			ScrollTrigger.refresh();
		}, 1000);
	}

	getDuration(scroller) {
		const cards = scroller.querySelectorAll(".shadow-container");
		const cardWidth = cards[0].clientWidth;
		const cardsCount = cards.length;
		const gap = 60;
		const blockWidth = scroller.clientWidth;
		const totalWidth = cardWidth * cardsCount + gap * cardsCount - gap + 240;
		const duration = totalWidth - blockWidth;
		return duration;
	}
}
